import {Component, OnInit} from '@angular/core';
import {Order, OrderMobile} from '../../models/order-list-filter-response';
import {MasmovilService} from '../../services/masmovil.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UserNotFoundComponent} from '../../../shared/components/user-not-found/user-not-found.component';
import {MatDialog} from '@angular/material/dialog';
import {OrderInfoResponse} from '../../models/order-info-response';
import {superStatus, typeCard} from '../../../shared/constantes';

const BRAND: string = 'masmovil';

@Component({
    selector: 'app-masmovil-order-detail',
    templateUrl: './masmovil-order-detail.component.html',
    styleUrls: ['./masmovil-order-detail.component.css', '../../../../assets/css/masmovil-theme.css'],
    standalone: false
})
export class MasmovilOrderDetailComponent implements OnInit {
    public loaded: boolean = false;
    public orderNotFound: boolean = false;

    public order: Order;

    constructor(
        public dialog: MatDialog,
        private activatedRoute: ActivatedRoute,
        private masmovilService: MasmovilService,
        public router: Router,
    ) {
    }

    ngOnInit(): void {
        this.getOrderInfo();
    }

    getOrderInfo(updateOrder?) {
        if (updateOrder) {
            this.loaded = false;
        }

        this.masmovilService.getOrderInfo(BRAND, this.activatedRoute.snapshot.paramMap.get('order_id'))
            .subscribe((data: OrderInfoResponse) => {
                if (data.msg.data.length === 0) {
                    this.router.navigate(['/masmovil/listado']);
                    return;
                }
                this.loaded = true;
                this.order = data.msg.data[0];
                this.orderNotFound = false;
            }, (error) => {
                if (error && error.error && error.error.error && error.error.error.errorCode !== null && error.error.error.errorCode === 462) {
                    this.dialog.open(UserNotFoundComponent, {
                        width: '350px',
                        disableClose: true,
                        data: {
                            marca: 'MásMóvil'
                        }
                    });
                } else {
                    this.orderNotFound = true;
                }
            });
    }

    getOrderStatus() {
        if (this.order) {
            if ((this.order.type == 'broadband' || this.order.type == 'convergent') && this.order.broadbands.length > 0) {
                return this.order.broadbands[0].status;
            }

            if (this.order.type == 'mobile' && this.order.mobiles.length > 0) {
                return this.order.mobiles[0].status;
            }

            if (this.order.type == 'sva' && this.order.services.length > 0) {
                return this.order.services[0].status;
            }
        }

        return '--';
    }

    getOrderTramitationDate() {
        if (this.order.tramited_at === null) {
            return '--';
        }

        const oldestDate = new Date(this.order.tramited_at);

        return new Intl.DateTimeFormat('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).format(oldestDate);
    }

    getTitleTypeMobile(mobile: OrderMobile) {
        if (mobile === undefined) {
            return '';
        }

        return mobile.is_portability ? `Línea móvil a portar ${mobile.msisdn}` : 'Alta línea móvil';

    }
}
